import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../lib/firebase";
import { Zap, Radio, ExternalLink } from "lucide-react";

export default function Live() {
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStreams = async () => {
      try {
        const q = query(collection(db, "content"), where("type", "==", "stream"), where("status", "==", "approved"), where("isLive", "==", true), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setStreams(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    };
    loadStreams();
  }, []);

  return (
    <div data-testid="live-page" className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-black text-white flex items-center gap-2">
          <Zap size={22} className="text-[#00ff77]" />
          Live Now
        </h1>
        <Link
          to="/dashboard/upload"
          data-testid="go-live-btn"
          className="bg-[#00ff77] text-black font-bold text-sm px-4 py-2 rounded-full hover:bg-[#00e66b] transition-colors"
        >
          Go Live
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-[#111] rounded-2xl h-32 animate-pulse" />
          ))}
        </div>
      ) : streams.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {streams.map((stream) => (
            <Link key={stream.id} to={`/content/${stream.id}`} data-testid={`live-stream-${stream.id}`}
              className="group bg-[#111] border border-white/5 rounded-2xl overflow-hidden hover:border-[#00ff77]/30 transition-all">
              <div className="relative aspect-video bg-[#1a1a1a]">
                {stream.thumbnailURL && <img src={stream.thumbnailURL} alt={stream.title} className="w-full h-full object-cover" />}
                <div className="absolute top-2 left-2">
                  <span className="flex items-center gap-1 text-xs bg-red-600 text-white font-bold px-2 py-0.5 rounded-full">
                    <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" /> LIVE
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-white text-sm font-semibold">{stream.title}</h3>
                <p className="text-zinc-500 text-xs mt-0.5">{stream.creatorName}</p>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-20 text-zinc-500">
          <Radio size={40} className="mb-4 opacity-30" />
          <p className="text-base font-semibold text-zinc-400 mb-1">No live streams happening right now.</p>
          <p className="text-sm mb-6">Be the first to go live — your audience is waiting.</p>
          <div className="flex items-center gap-3">
            <Link to="/auth?mode=register" data-testid="signup-live-btn"
              className="bg-[#00ff77] text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-[#00e66b] transition-colors">
              Sign Up &amp; Go Live
            </Link>
            <Link to="/explore?cat=Previously+Recorded"
              className="border border-white/10 text-white text-sm px-5 py-2.5 rounded-full hover:border-white/30 transition-colors">
              Browse Previously Recorded
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
